var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4751 5.2C5.4751 6.31391 5.9176 7.3822 6.70525 8.16985C7.4929 8.9575 8.56119 9.4 9.6751 9.4C10.789 9.4 11.8573 8.9575 12.6449 8.16985C13.4326 7.3822 13.8751 6.31391 13.8751 5.2C13.8751 4.08609 13.4326 3.0178 12.6449 2.23015C11.8573 1.4425 10.789 1 9.6751 1C8.56119 1 7.4929 1.4425 6.70525 2.23015C5.9176 3.0178 5.4751 4.08609 5.4751 5.2V5.2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05566 3.06728C6.70592 3.74196 7.48556 4.27858 8.34797 4.64504C9.21038 5.0115 10.1378 5.20028 11.0749 5.20008C12.024 5.20045 12.9632 5.00689 13.8349 4.63128",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 19.0001C1.875 16.9314 2.69678 14.9475 4.15957 13.4847C5.62235 12.0219 7.60631 11.2001 9.675 11.2001C11.7437 11.2001 13.7276 12.0219 15.1904 13.4847C16.6532 14.9475 17.475 16.9314 17.475 19.0001",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67505 11.7992V12.4C6.67505 13.1956 6.99112 13.9587 7.55373 14.5213C8.11634 15.0839 8.8794 15.4 9.67505 15.4C10.4707 15.4 11.2338 15.0839 11.7964 14.5213C12.359 13.9587 12.675 13.1956 12.675 12.4V11.7992",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 12.8512V19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4751 12.8512V19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.66bab6849bfd61e95b2609e6d6c5adf9.svg";
export { ForwardRef as ReactComponent };